import React, { useEffect, useState } from "react";
import SectionAbout from "../components/SectionAbout";
import SwitchComponents from "../components/SwitchComponents";
import excelFile from '../../src/data.xlsx';
import ReadExcel from "../components/utils/ReadExcel";
import title from "../assets/hero-image.webp";

export default function Home() {
  useEffect(() => {
    document.title = "Erik Schott - Portfolio";
  }, []);

  const [excelData, setExcelData] = useState({ About: [] });

  const handleDataLoad = (data) => {
    setExcelData(data);
  };

  return (
    <>
      <ReadExcel filePath={excelFile} onDataLoad={handleDataLoad}></ReadExcel>
      <div className="page-wrapper">
        <div className="content-wrapper">
          <div
            className="hero-wrapper"
            style={{
              backgroundColor: "var(--primary-bg)",
              backgroundPosition: "top",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundImage: `url(${title})`,
            }}
          >
            <h1
              className="title"
              style={{
                whiteSpace: "pre-line",
                position: "absolute",
                top: "77.5%",
                left: "-2rem",
                right: "-2rem",
              }}
            >
              Erik<br />Schott
            </h1>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h1 className="h1">Mein Angebot</h1>
            <h2 className="h4">Was mache ich?</h2>
          </div>
          <SwitchComponents />
        </div>
        <div className="content-wrapper">
          <div className="content-head">
            <h1 className="h1">About</h1>
            <h2 className="h4">Wer bin ich?</h2>
          </div>
          {excelData.About?.length > 0 ? (
            <SectionAbout
              titel={excelData.About[0].titel}
              beschreibung={excelData.About[0].beschreibung}
              image_01={excelData.About[0].image_01}
            />
          ) : (
            <div className="bodycopy">Die Daten laden...</div>
          )}
        </div>
      </div>
    </>
  );
}